/**
 * PostHog custom event tracking for Nakamoto Daily.
 *
 * Tracks:
 * - Article metadata (author, tags, word count) via super-properties
 * - Article share clicks (share, twitter, copy-link)
 * - Newsletter signup submissions
 *
 * PostHog's built-in pageview/pageleave handles the rest
 * (page views, sessions, bounce rate, scroll depth, referrers, UTMs).
 */

function getPosthog() {
    return window.posthog;
}

/**
 * Register article-level properties so every event on an article page
 * automatically includes this context. PostHog docs recommend register()
 * for properties that apply to all events on a page.
 */
function trackArticleProperties() {
    const ph = getPosthog();
    if (!ph) return;

    const article = document.querySelector("article.post");
    if (!article) return;

    const title = document.querySelector(".post-title")?.textContent?.trim();
    const authorEl = document.querySelector(".post-author-name a");
    const tags = Array.from(document.querySelectorAll(".post-tags a")).map(
        (el) => el.textContent.trim()
    );
    const content = document.querySelector(".post-content");
    const wordCount = content
        ? content.textContent.trim().split(/\s+/).length
        : 0;

    ph.register_for_session({
        article_title: title,
        article_author: authorEl?.textContent?.trim(),
        article_tags: tags,
        article_word_count: wordCount,
    });
}

/**
 * Track share button clicks with the share method used.
 * Hooks into existing data-attributes already in share.js.
 */
function trackShareClicks() {
    const ph = getPosthog();
    if (!ph) return;

    const shareMap = {
        "data-share-button": "native_share",
        "data-twitter-share-button": "twitter",
        "data-copy-button": "copy_link",
    };

    Object.entries(shareMap).forEach(([attr, method]) => {
        document.querySelectorAll(`[${attr}]`).forEach((el) => {
            el.addEventListener("click", () => {
                ph.capture("article_shared", {
                    share_method: method,
                    share_url: el.getAttribute("data-share-url") ||
                        el.getAttribute("data-copy-button"),
                });
            });
        });
    });
}

/**
 * Track newsletter signup form submissions.
 * Uses MutationObserver on Ghost's data-members-form to detect
 * successful submissions (Ghost adds a "success" class).
 */
function trackNewsletterSignups() {
    const ph = getPosthog();
    if (!ph) return;

    document
        .querySelectorAll('[data-members-form="subscribe"]')
        .forEach((form) => {
            let tracked = false;
            const observer = new MutationObserver(() => {
                if (!tracked && form.classList.contains("success")) {
                    tracked = true;
                    ph.capture("newsletter_signup", {
                        form_location: form.closest(".newsletter-box")
                            ? "inline"
                            : "other",
                    });
                    observer.disconnect();
                }
            });
            observer.observe(form, {
                attributes: true,
                attributeFilter: ["class"],
            });
        });
}

const analytics = () => {
    if (!getPosthog()) return;

    trackArticleProperties();
    trackShareClicks();
    trackNewsletterSignups();
};

export default analytics;
